import {
  Box,
  Button,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { MdLockOutline } from "react-icons/md";
import { RiDeleteBin6Line, RiEyeFill, RiEyeOffFill } from "react-icons/ri";
import DeleteFileConfirmModal from "../../../Modals/DeleteFileConfirmModal";

const SingleBankStatement = ({
  name,
  scannedCopyDetected,
  detectedMessage,
  isLast,
}) => {
  // useDisclosure for Password Modal
  const {
    isOpen: isPasswordModalOpen,
    onOpen: openPasswordModal,
    onClose: closePasswordModal,
  } = useDisclosure();

  // useDisclosure for Delete Confirmation Modal
  const {
    isOpen: isDeleteModalOpen,
    onOpen: openDeleteModal,
    onClose: closeDeleteModal,
  } = useDisclosure();

  const inputRef = useRef(null); // Use ref for password input
  const [showPassword, setShowPassword] = useState(false); // Toggle state for showing/hiding password
  const [deleteFileLoader, setDeleteFileLoader] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle between showing and hiding password
    if (inputRef.current) {
      inputRef.current.type = showPassword ? "password" : "text"; // Change input type
    }
  };

  const handleSavePassword = () => {
    const password = inputRef.current.value; // Access password using ref
    closePasswordModal();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      borderBottomWidth={isLast ? "0" : "1px"} // Only show border for non-last items
      borderBottomColor="gray.300"
      paddingY={"2px"}
    >
      {/* Document Icon and Name */}
      <Box display="flex" alignItems="center">
        <MdLockOutline size={16} color="#FFA500" />
        <Text fontSize={"sm"} ml={2}>
          {name}
        </Text>
      </Box>

      {/* Add Password Button with Modal */}
      <Box>
        <Button
          variant={"unstyled"}
          fontSize={"sm"}
          color={"gray.400"}
          onClick={openPasswordModal}
          display={"flex"}
          columnGap={1}
        >
          <MdLockOutline /> <Text fontSize={"xs"}>Add Password</Text>
        </Button>

        {/* Modal for Password Entry */}
        <Modal
          isOpen={isPasswordModalOpen}
          onClose={closePasswordModal}
          colorScheme="teal"
          isCentered
          size={"sm"}
        >
          <ModalOverlay />
          <ModalContent borderRadius={"20px"} py={3} px={1}>
            <ModalHeader>Add Password</ModalHeader>
            <ModalBody>
              <Text>Password</Text>
              <Box
                display="flex"
                alignItems="center"
                position="relative"
                mt={2}
              >
                <Input
                  type={showPassword ? "text" : "password"} // Show/hide password
                  placeholder="Enter password"
                  focusBorderColor="teal.500"
                  ref={inputRef} // Assign ref to input
                  pr="3rem" // Add padding to the right for the eye icon
                />
                <IconButton
                  icon={showPassword ? <RiEyeOffFill /> : <RiEyeFill />}
                  onClick={togglePasswordVisibility}
                  size="sm"
                  position="absolute"
                  right="10px"
                  aria-label="Toggle password visibility"
                  variant="ghost"
                  zIndex="1" // Ensure icon is above the input
                />
              </Box>
            </ModalBody>

            <ModalFooter
              display={"flex"}
              flexDirection={"column"}
              rowGap={2}
              alignItems={"center"}
            >
              <Button
                width={"100%"}
                onClick={handleSavePassword}
                colorScheme="teal"
              >
                Save
              </Button>
              <Button
                width={"100%"}
                onClick={closePasswordModal}
                variant={"outline"}
              >
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>

      {/* Scanned Copy Detection or Delete Icon */}
      <Box display="flex" alignItems="center">
        {scannedCopyDetected ? (
          <Text color="red.500" fontSize={"xs"} fontWeight="bold" mr={4}>
            {detectedMessage}
          </Text>
        ) : (
          <>
            <IconButton
              icon={<RiDeleteBin6Line />}
              color={"red.500"}
              variant="ghost"
              aria-label="Delete Document"
              size="md"
              onClick={openDeleteModal} // Trigger delete modal on click
            />
            {/* Modal for confirming deletion */}
            <DeleteFileConfirmModal
              isOpen={isDeleteModalOpen}
              onClose={closeDeleteModal}
              deleteFileLoader={deleteFileLoader}
              setDeleteFileLoader={() => {
                setDeleteFileLoader(true);
                setTimeout(() => {
                  setDeleteFileLoader(false);
                  closeDeleteModal();
                }, 5000);
              }}
            />
          </>
        )}
      </Box>
    </Box>
  );
};

export default SingleBankStatement;
